import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import {
  MatButtonToggleChange,
  MatButtonToggleModule,
} from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { ToggleGroupOptions } from '@data-access/shared';
import {
  SegmentedButtonsDirective,
  SegmentedButtonsIconDirective,
} from '@wcg/frontend-framework';

@Component({
  selector: 'wcg-ui-grid-toggle-group',
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonToggleModule,
    SegmentedButtonsDirective,
    SegmentedButtonsIconDirective,
  ],
  template: `
    <div class="relative">
      <mat-button-toggle-group
        wcg-segmented-buttons
        [value]="value()"
        (change)="onToggleChange($event)"
      >
        @for (option of options(); track option.value) {
          <mat-button-toggle [value]="option.value">
            <mat-icon wcg-segmented-buttons-icon fontIcon="check"></mat-icon>
            {{ option.label }}
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>
  `,
})
export class UiGridToggleGroupComponent {
  // dynamic options
  options = input<ToggleGroupOptions[]>([]);

  // selected value
  value = input<string>('');

  // emit value 'changes'
  valueChange = output<string>();

  onToggleChange(event: MatButtonToggleChange) {
    this.valueChange.emit(event.value);
  }
}
